<div class="quick-feedback-container">
  <div class="vote-icon">
    <mat-icon>how_to_vote</mat-icon>
  </div>
  <div class="rate">
    <div class="text">
      @for (question of questionsUnwrapped; track $index; let i = $index) {
      <span [class.active]="question === activeQuestion">
        @if (i === 0) {
        <strong>{{ 'liveEvent.feedback.title' | translate }}: </strong>
        }
        {{ question.text }}
      </span>
      }
    </div>
    <div
      class="options"
      [class.voted]="activeQuestion.finished"
      [class.showing]="activeQuestion?.answers || false"
    >
      @for (answer of activeQuestion.answers; track $index) {
      <div
        class="option"
        [matTooltip]="answer.tooltip || ''"
        (click)="logInResp(answer)"
        [class.con]="answer.warn"
        [class.isText]="answer.text"
      >
        @if (answer.icon) {
        <mat-icon>{{ answer.icon }}</mat-icon>
        } @if (answer.text) {
        <span>{{ answer.text }}</span>
        }
      </div>
      }
    </div>
    <div class="textinput" [class.visible]="activeQuestion.textInput || false">
      <form (submit)="logInText()">
        <mat-form-field appearance="fill">
          <mat-label>{{ 'liveEvent.feedback.answer' | translate }}</mat-label>
          <input
            autocomplete="off"
            matInput
            [formControl]="feedbackText"
            [placeholder]="activeQuestion?.textInput?.placeholder || ''"
          />
        </mat-form-field>
        <qa-button
          [isRaisedButton]="true"
          label="liveEvent.feedback.submit"
          type="submit"
        ></qa-button>
      </form>
    </div>
  </div>
</div>
